import {Breadcrumb, Facet, FacetValue, Feature, Price, Product, ProductSearchPage} from '@spartacus/core'

export interface EbProduct extends Product {
  ebProductType?: EbProductTypeEnum
  products?: EbProduct[]
  documents?: EBDocument[]
  classifications?: EBClassification[]
  classificationAttributes?: EBClassificationAttributes
  configurable?: boolean
  drawingNumber?: string
  successor?: EbProduct
  orderable?: boolean
  approved?: boolean
  customerMaterialNumber?: string
  parentProductId?: string
  parentProductName?: string
  breadcrumbs?: Breadcrumb[]
  fullProductPath?: string
  parentProductFullPath?: string
  predecessors?: string[]
  productSalesView?: EBProductSalesView
  expirationDate?: string
  isExpiring?: boolean
  code?:string
}

export interface EBClassificationAttributes {
  vc_nominal_size?: string
  mm_seat_design?: string
  bm_seal_face?: string
  bm_seat?: string
  bm_secondary_seal?: string
  bm_metal_parts?: string
}

export interface EbFeature extends Feature {
  position?: number
}

export interface EBClassification {
  code?: string
  name?: string
  features?: EbFeature[]
}

export interface EBFacet extends Facet {
  specialFacet: boolean
}

export interface EbVariantSearchPageItem extends EbProduct {
  vc_nominal_size?: string[]
  mm_seat_design?: string[]
  bm_seal_face?: string[]
  bm_seat?: string[]
  bm_secondary_seal?: string[]
  bm_metal_parts?: string[]
}

export interface EbFacetValue extends FacetValue {
  code?: string
  unit?: string
  imageUrl?: string
}

export interface EbFacet extends Facet {
  code?: string
  unit?: string
  values?: EbFacetValue[]
  specialFacet?: boolean
  selectionType?: EbFacetSelectionTypeEnum
}

export interface EbProductSearchPage extends ProductSearchPage {
  keywordRedirectUrl?: string
  facets?: EbFacet[]
  categoryName?: string
  categoryDescription?: string
  categoryImage?: string
  features?: Feature[]
  fuzzyProducts?: EbProduct[]
}

export interface EbVariantSearchPage extends EbProductSearchPage {
  products: EbVariantSearchPageItem[]
  facets?: EbFacet[]
}

export interface EBDocument {
  code: string
  url: string
  downloadUrl: string
  ebMediaType: EbMediaTypeEnum
}

export interface EbProductPrice {
  isCartCalculation?: boolean
  currency?: string
  priceTotalValue?: Price
  priceTotalTextId?: string
  additionalTextId?: string
  items: EbProductPriceItem[]
}

export interface EbProductPriceItem {
  itemId?: string
  product: string
  quantity?: number
  unit?: string
  itemNetPricePerUnit?: Price
  itemNetPriceTotal?: Price
  scales?: EbProductScalePrice[]
}

export interface EbProductScalePrice {
  itemNo: string
  quantity: number
  unit: string
  scalePrice: EbScalePrice
}

export interface EbScalePrice {
  currencyIso: string
  value: number
  formattedValue: string
}

export interface EbPrice extends Price {
  textId?: string
}

export interface EBProductSalesView {
  salesText?: string
  minOrderQuantity?: number
  deliveryQuantity?: number
  minDeliveryQuantity?: number
  deliveryQuantityUnit?: EBUnit
  salesUnit?: EBUnit
}

export interface EBUnit {
  code?: string
  name?: string
  conversion?: number
}

export interface EBBreadcrumb extends Breadcrumb {
  facetNameEn?: string;
}

export enum EbProductTypeEnum {
  PARENT = 'PARENT',
  VARIANT = 'VARIANT'
}

export enum EbMediaTypeEnum {
  PICTURE = 'PICTURE',
  DRAWING = 'DRAWING',
  MANUAL = 'MANUAL',
  DATASHEET = 'DATASHEET'
}

export enum EbSortingVariants {
  NAMEASC = 'nameAsc',
  RELEVANCE = 'relevance',
  NAMEDESC = 'nameDesc'
}

export enum EbFacetSelectionTypeEnum {
  SINGLE = 'SINGLE',
  MULTISELECT = 'MULTISELECT',
  RANGE = 'RANGE'
}
